import { motion } from 'framer-motion';

export const FeaturedName = ({ children, delay = 0 }) => {
    const walmartTextSize = 'text-2xl';

    return (
        <motion.span
            className={`inline-block ${walmartTextSize} font-bold leading-tight tracking-tight`}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
                duration: 0.7,
                delay,
                ease: [0.22, 1, 0.36, 1],
            }}
        >
            <motion.span
                className="inline-block"
                style={{
                    color: 'transparent',
                    backgroundImage: `
                        linear-gradient(
                            115deg,
                            #94a3b8 0%,
                            #94a3b8 42%,
                            #e2e8f0 46%,
                            #ffffff 50%,
                            #e2e8f0 54%,
                            #94a3b8 58%,
                            #94a3b8 100%
                        )
                    `,
                    backgroundSize: '280% 100%',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    filter: `
                        drop-shadow(0 2px 4px rgba(0, 0, 0, 0.45))
                        drop-shadow(0 0 10px rgba(255, 255, 255, 0.3))
                    `,
                }}
                animate={{
                    // Broad, noticeable glide across the letters that turns back smoothly
                    backgroundPosition: ['75% 50%', '25% 50%'],
                }}
                transition={{
                    duration: 2.2,
                    delay,
                    repeat: Infinity,
                    repeatType: 'reverse',
                    ease: [0.45, 0.05, 0.55, 0.95],
                }}
            >
                {children}
            </motion.span>
        </motion.span>
    );
};
